import { Component, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { Atividade } from 'src/app/core/atividade';
import { MateriaisAtividade } from 'src/app/core/materiais-atividade';
import { Material } from 'src/app/core/material';
import { MaterialService } from 'src/app/services/material/material.service';
import { ComboMaterial } from '../../../../core/combo-material';
import { DataUtilService } from "../../../../services/commons/data-util.service";

@Component({
    selector: 'cadastrar-materiais',
    templateUrl: './cadastrar-materiais.component.html',
    styleUrls: ['./cadastrar-materiais.component.css']
})
export class CadastrarMateriaisComponent implements OnInit {

    @Input() oficina: Atividade;
    materialAtividade: MateriaisAtividade;
    comboMaterialSelecionado: ComboMaterial;
    listaDeMateriais: Material[] = [];

    isAtualizar = false;
    isMostrarFuncionario = false;

    formasPagamento = [
        {tipo: 'D', descricao: 'Dinheiro'},
        {tipo: 'C', descricao: 'Cartão'},
        {tipo: 'D', descricao: 'Débito'},
        {tipo: 'F', descricao: 'Desconto em folha'},
    ];

    constructor(
        private materialService: MaterialService,
        private dataUtilService: DataUtilService
    ) {
    }

    ngOnInit() {
        this.zerarCombos();
        this.materialService.getAll().subscribe((materiais: Material[]) => {
            this.listaDeMateriais = materiais;
            if (this.listaDeMateriais && this.listaDeMateriais.length > 0) {
                this.montarComboMaterial(this.listaDeMateriais[0].id);
            }
        });
    }


    zerarCombos() {
        this.materialAtividade = new MateriaisAtividade();
        this.materialAtividade.material = new Material();
        this.isMostrarFuncionario = false;
    }

    adicionar() {
        this.montarMaterial(this.comboMaterialSelecionado.id);
        const materialAtividade = new MateriaisAtividade();
        Object.assign(materialAtividade, this.materialAtividade);
        if (!this.oficina.materiaisAtividade) {
            this.oficina.materiaisAtividade = [];
        }
        this.oficina.materiaisAtividade.push(materialAtividade);
        this.zerarCombos();
    }


    montarMaterial(idMaterial: number) {
        this.materialAtividade.material = _.cloneDeep(_.find(this.listaDeMateriais, (m: Material) => m.id === idMaterial));
    }

    atualizar() {
        const index = this.oficina.materiaisAtividade.indexOf(this.oficina.materiaisAtividade.find(col => col.id === this.materialAtividade.id));
        this.oficina.materiaisAtividade.splice(index, 1, this.materialAtividade);
        this.isAtualizar = false;
        this.zerarCombos();
    }

    atualizarMaterial(materialAtividade: MateriaisAtividade) {
        if (materialAtividade && materialAtividade.material && materialAtividade.material.id) {
            this.montarComboMaterial(materialAtividade.material.id);
        }
        this.isAtualizar = true;
        this.materialAtividade = materialAtividade;
    }

    cancelar() {
        this.zerarCombos();
        this.isAtualizar = false;
    }

    onMascaraDataInput(event) {
        return this.dataUtilService.onMascaraDataInput(event);
    }

    onValorChangeMaterial(registro: any) {
        if (registro && registro.id) {
            this.montarMaterial(registro.id);
            this.montarComboMaterial(registro.id);
        }
    }

    montarComboMaterial(id: number) {
        this.listaDeMateriais.forEach(m => {
            if (m.id == id) {
                this.comboMaterialSelecionado = { id: m.id, nome: m.nome };
            }
        });
    }

}
